// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn-wrapper {\n  display: flex;\n  justify-content: center;\n  padding: 20px 0 30px;\n}\n.btn-wrapper .btn {\n  font-size: 14px;\n  align-items: center;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
